// src/app/guards/baneo.guard.ts
import { Injectable, computed, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';          // ← importado
import { UserService } from '../services/user.service';
import { Usuario } from '../models/usuario.interface';

@Injectable({ providedIn: 'root' })
export class BaneoGuard implements CanActivate {
  private authService = inject(AuthService);                     // ← inyectado
  private userService = inject(UserService);
  private router      = inject(Router);

  async canActivate(): Promise<boolean | UrlTree> {
    // 0) Esperar a que Firebase Auth confirme la sesión
    await this.authService.initAuth();

    // 1) Ahora la señal de usuario debería estar inicializada
    const usuarioComputed = computed(() => this.userService.usuarioSignal());

    // 2) Pequeño polling sólo si la señal sigue en null
    const maxChecks = 20;
    let checks = 0;
    while (usuarioComputed() === null && checks < maxChecks) {
      await new Promise(res => setTimeout(res, 100));
      checks++;
    }

    const user: Usuario | null = usuarioComputed();

    // 3) Si no existe usuario (quizá ruta pública), dejamos pasar
    if (!user) {
      return true;
    }

    // 4) Si está baneado, redirigimos
    if (!user.activo) {
      console.warn('Usuario baneado detectado, redirigiendo...');
      return this.router.parseUrl('/baneado');
    }

    return true;
  }
}
